import * as React from 'react';
import { createSelectable, TSelectableItemProps } from '../../../components/drag-select';

// The actual contract of this control.
//
// The TS compiler isn't working with the drag
// library we use so we're falling back to props
// of any in order to compile.
interface IProps extends TSelectableItemProps {
    hourItem: any;
}

class AddressHourBox extends React.Component<any> {

    public render() {

        const { selectableRef, isSelected, isSelecting, hourItem } = this.props;

        let hourStr = '';
        if (hourItem.hour === 0) {
            hourStr = '12';
        }
        else if (hourItem.hour > 12) {
            hourStr = (hourItem.hour - 12).toString();
        }
        else {
            hourStr = hourItem.hour.toString();
        }

        return <div
                className={
                    'hour-box ' +
                    (isSelecting ? 'active' : '') +
                    (isSelected ? 'selected' : '')
                }
                ref={selectableRef}>
                    <span>
                    {
                        (hourItem.index % 2) === 0 ? hourStr : '-'
                    }
                    </span>
            </div>;
    }

}

export default createSelectable(AddressHourBox);
